import React from 'react'
import NextImage from 'next/image'
import Link from 'next/link'

import { Text } from '@wartek-id/text'

import { useQueryAPIGetKSSelectionCandidateBanner } from 'api/bcks/useAPIBCKSInvitation'
import useKSPSTrackEvent from 'app/BCKSPage/hooks/useKSPSTrackEvent'

export const KSSelectionCard = () => {
  const { KSPSTrackEvent } = useKSPSTrackEvent()

  const { data: bannerData, isError: isErrorGetBannerData } =
    useQueryAPIGetKSSelectionCandidateBanner()

  const icon = React.useMemo(() => {
    switch (bannerData?.icon) {
      case 'stages.png':
        return '/illustrations/img-collect-files-folder.png'
      case 'collection.png':
        return '/images/bcks/img-invitation-default.png'
      case 'verval.png':
        return '/images/bcks/img-files-magnifying-glass-progress.png'
      case 'announcement.png':
        return '/illustrations/img-announcement-speaker.png'
      default:
        return ''
    }
  }, [bannerData])

  const shouldShowDynamicBanner = bannerData && !isErrorGetBannerData

  if (!shouldShowDynamicBanner) {
    return null
  }

  return (
    <section className="px-4">
      <Text
        variant="heading-md"
        className="mb-2"
        as="h2"
        data-testid="ks-selection-card"
      >
        {bannerData.header}
      </Text>

      <div className="space-y-4">
        <div className="rounded-lg shadow p-4 flex justify-between space-x-4 bg-white">
          <div className="flex flex-col items-start gap-4">
            <div className="space-y-2">
              <Text
                dangerouslySetInnerHTML={{ __html: bannerData.description }}
                data-testid="ks-selection-card-description"
              />
            </div>

            {bannerData.button?.text && bannerData.button?.redirection && (
              <Link href={bannerData.button?.redirection} passHref>
                <a
                  className="min-w-36 text-center text-sm font-semibold rounded py-1.5 px-6"
                  style={{
                    backgroundColor: bannerData.button?.backgroundColor,
                    color: bannerData.button?.textColor,
                  }}
                  onClick={() => {
                    KSPSTrackEvent({
                      event_name: 'click_ksps_banner',
                      additional_info: [
                        {
                          key: 'cta_banner',
                          value: bannerData.button?.text,
                        },
                      ],
                    })
                  }}
                  data-testid="ks-selection-card-link"
                >
                  {bannerData.button?.text}
                </a>
              </Link>
            )}
          </div>
          <div className="flex flex-col justify-center shrink-0">
            <NextImage
              src={icon}
              width={60}
              height={60}
              alt="Seleksi Kepala Sekolah"
              data-testid="ks-selection-card-image"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
